<template>
	<div
		class="grid amount-holder grid--center-vertical"
		v-if="hasPrice">
		<h3
			class="amount-title"
			v-if="!table && !clean"
			:class="{'amount-title--overview' : overview}">
			Aantal:
		</h3>
		<div
			v-if="amountData.customAmountAllowed"
			class="amount-input"
			:class="{'amount-input--table' : table}">
			<button
				class="amount-button background-indigo-025"
				@click="amountDecrement()">-</button>
			<input
				class="amount-field"
				:class="{'amount-field--invalid' : !valid}"
				type="number"
				:min="amountData.minAmount"
				:max="!offsetAvailable ? amountData.maxAmount : 9999999999"
				v-model.number="amount"
				@input="validateAmount">
			<button
				class="amount-button background-indigo-025"
				@click="amountIncrement()">+</button>
		</div>
		<div class="dropdown-container" v-if="!amountData.customAmountAllowed">
			<select
				class="amount-field"
				v-model.number="amount"
				@input="validateAmount">
				<option
					v-for="(amount, key) in amountData.amountList"
					:key="key"
					:values="amount"
					:selected="amount === getOrderLine.amount">
					{{ amount }}
				</option>
			</select>
		</div>
	</div>
</template>

<script>
import { EventBus } from "@/store/index.js";
import { Events, pushEvent } from "@/helpers/tracking.js";

export default {
	name: "Amount",
	data () {
		return {
			valid: false,
			message: "",
			openModal: false,
			timeout: null,
			quoteModalDebounceTimeout: null
		};
	},
	props: {
		table: {
			type: Boolean,
			default: false
		},
		overview: {
			type: Boolean,
			default: false
		},
		clean: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		hasPrice () {
			return this.$store.getters.getPrice != null;
		},
		getOrderLine () {
			return this.$store.getters.getOrderLine;
		},
		amountData () {
			return this.$store.getters.getAmountData;
		},
		offsetAvailable () {
			return this.$store.getters.currentConfigSupportsOffset;
		},
		isOffset () {
			return this.$store.getters.isOffset;
		},
		isConfiguratorDataValid () {
			return this.$store.getters.isConfiguratorDataValid;
		},
		hasQuotation () {
			return this.$store.state.baseProps.hasQuotation === "true";
		},
		getOffsetAmounts () {
			return this.$store.getters.getOffsetPriceTable.map(line => line.Amount);
		},
		amount: {
			get () {
				return this.getOrderLine.amount;
			},
			set (a) {
				if (Number.isInteger(a)) {
					if (!this.isOffset) {
						if (a < this.amountData.minAmount) {
							a = this.amountData.minAmount;
						} else if (a > this.amountData.maxAmount) {
							clearTimeout(this.quoteModalDebounceTimeout);

							if (this.hasQuotation) {
								this.quoteModalDebounceTimeout = setTimeout(() => {
									EventBus.$emit("openQuoteModal");
								}, 700);
							}

							a = this.amountData.maxAmount;
						}
						if (!this.amountData.customAmountAllowed) {
							if (this.amountData.amountList.includes(a)) {
								this.setOrderLineAmount(a);
							}
						} else {
							this.setOrderLineAmount(a);
						}
					} else {
						this.setOrderLineAmount(this.getClosestOffsetAmount(a));
					}
				}
			}
		}
	},
	methods: {
		setOrderLineAmount (amount) {
			const previousAmount = this.getOrderLine.amount;
			this.$store.commit("SET_ORDERLINE_AMOUNT", amount);
			if (this.isOffset) {
				this.$store.commit("SET_CONFIGURATION_OFFSET_PRICE", amount);
			}

			pushEvent(Events.CHANGE_QUANTITY, {
				previousAmount: previousAmount,
				newAmount: amount,
				isCustomAmount: this.amountData.customAmountAllowed
			});
		},
		setOffset (offset) {
			this.$store.commit("SET_OFFSET_SELECTED", offset);
		},
		validateAmount () {
			if (this.amount < this.amountData.minAmount) {
				this.valid = false;
				this.amount = this.amountData.minAmount;
			} else if (this.amount > this.amountData.maxAmount) {
				this.valid = false;
				this.amount = this.amountData.maxAmount;
			} else {
				this.valid = true;
				this.amount = this.amount;
			}
		},
		getClosestOffsetAmount (amount) {
			return this.getClosest(amount, this.getOffsetAmounts);
		},
		getNextOffsetAmount (amount, offsetAmounts) {
			return offsetAmounts[offsetAmounts.indexOf(amount) + 1];
		},
		getPreviousOffsetAmount (amount, offsetAmounts) {
			return offsetAmounts[offsetAmounts.indexOf(amount) - 1];
		},
		getClosest (num, arr) {
			let curr = arr[0];
			let diff = Math.abs(num - curr);
			for (let val = 0; val < arr.length; val++) {
				const newdiff = Math.abs(num - arr[val]);
				if (newdiff < diff) {
					diff = newdiff;
					curr = arr[val];
				}
			}
			return curr;
		},
		amountIncrement () {
			this.setOffset(false);
			this.amount++;
			if (this.amount > this.amountData.maxAmount) {
				this.amount = this.amountData.maxAmount;
			}
		},
		amountDecrement () {
			this.setOffset(false);
			this.amount--;
			if (this.amount < this.amountData.minAmount) {
				this.amount = this.amountData.minAmount;
			}
		}
	},
	mounted () {
		this.validateAmount();
	}
};
</script>

<style lang="scss">
.amount-title {
  display: inline-block;

  &--overview {
    color: var(--cfg-primary-dark);
    font-size: 2.3rem;
    margin-bottom: 0;
    padding-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/element/amount.vue